// extracted by mini-css-extract-plugin
export var discard = "_2e-3";
export var muiTooltipTooltip = "_2e-5";
export var notificationBar = "_2e-2";
export var saveButtonHoverSlotWrapper = "_2e-4";
export var show = "_2e-1";
export var spacer = "_2e-0";